// import { gsap } from 'gsap';

// class LineUpArtist {
//     constructor() {
//         LineUpArtist.handleAnimation();
//     }

//     static handleAnimation() {
//         const hoverItems = gsap.utils.toArray('[data-hover-img]');

//         hoverItems.forEach((item) => {

//             // extract the image url from a
//             item.image = item.getAttribute('data-hover-img');

//             // create elements & append to DOM
//             const follower = document.createElement('span');
//             follower.classList.add('line-up-tooltip');
//             follower.style.cssText = `background: no-repeat center / cover url("${item.image}") #000000;`;
//             item.appendChild(follower);

//             // animation   
//             const hoverAnimation = gsap.fromTo(follower,
//                 {
//                     opacity: 0,
//                     scale: 0.1,
//                 },
//                 {
//                     opacity: 1,
//                     scale: 1,
//                     duration: 0.25,
//                     ease: 'circ.inOut',
//                     paused: true
//                 });

//             item.addEventListener('mouseenter', () => {
//                 hoverAnimation.play();
//             });

//             item.addEventListener('mouseleave', () => {
//                 hoverAnimation.reverse();
//             });

//             item.addEventListener('mousemove', (e) => {
//                 gsap.to(follower, {
//                     x: e.offsetX,
//                     y: e.offsetY,
//                     duration: 0.1,
//                     ease: 'power2.inOut'
//                 });
//             });

//         });
//     }
// }

// new LineUpArtist(); // eslint-disable-line no-new